import { DefaultFocusStatusModel } from "../../../models/DefaultFocusStatusModel";
import { KeyboardNavigation } from "./KeyboardNavigation";

export class NumericRankingNavigation extends KeyboardNavigation {
    findNextFocusableElementWithinSameVariable(
        currentElement: DefaultFocusStatusModel,
        eventKey: string,
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        if (eventKey === "ArrowDown" || eventKey === "ArrowRight") {
            for (let i = index; i < this.defaultFocusStatus.statuses.length; i++) {
                const elementFocusStatus = this.defaultFocusStatus.statuses[i];

                if (
                    elementFocusStatus.variableId === currentElement.variableId &&
                    elementFocusStatus.elementId !== currentElement.elementId
                ) {
                    return elementFocusStatus;
                }
            }
        } else if (eventKey === "ArrowUp" || eventKey === "ArrowLeft") {
            for (let i = index; i >= 0; i--) {
                const elementFocusStatus = this.defaultFocusStatus.statuses[i];
                if (
                    elementFocusStatus.variableId === currentElement.variableId &&
                    elementFocusStatus.elementId !== currentElement.elementId
                ) {
                    return elementFocusStatus;
                }
            }
        }

        return null;
    }

    findNextFocusableElementWithinNextVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        return this.findNextFocusableElementWithinNextVariableCommon(currentElement);
    }

    findLastFocusableElementWithinPreviousVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        return this.findLastFocusableElementWithinPreviousVariableCommon(
            currentElement,
        );
    }
}
